/* eslint-disable @next/next/no-img-element */
import {ReactElement, useState} from 'react';
import ImageLoader from '../../../services/image-loader';
import StyledImgFigure from './styles';
import Props, {LoaderType} from './typings';

const Image = ({
  path,
  alt,
  mainColor = 'ebe8e5',
  width = 0,
  srcSetDef,
  sizes,
  height = 0,
  quality = 100,
  responsive,
  loading = 'lazy',
  fallbackWidth,
  retina = false,
  preview = false,
}: Props): ReactElement => {
  const [loaded, setLoaded] = useState(false);

  const isLoader = (loader: string): loader is LoaderType => {
    switch (loader) {
      case 'thumbor':
      case 'default':
        return true;
      default:
        console.error('Wrong loader is passed to image!');
        return false;
    }
  };

  const getLoader = (path, width, height, quality): string => {
    if (!path) return '';

    let loader;
    if (process.env.NEXT_IMAGE_LOADER && isLoader(process.env.NEXT_IMAGE_LOADER)) {
      loader = process.env.NEXT_IMAGE_LOADER;
    } else {
      loader = 'default';
    }
    // eslint-disable-next-line new-cap
    return ImageLoader(path, width, quality, height).get(loader);
  };

  const sizeMultiplier = retina ? 2 : 1;
  const srcImgWidth = fallbackWidth ?? width * sizeMultiplier;
  const srcImgHeight = height * sizeMultiplier;
  const previewWidth = fallbackWidth ?? width / 100;
  const previewHeight = height / 100;

  return (
    <StyledImgFigure
      $mainColor={mainColor}
      $width={width}
      $height={height}
      $responsive={responsive}
      $preview={preview ? getLoader(path, previewWidth, previewHeight, 15) : undefined}
      $imageLoaded={loaded}
    >
      <img
        loading={loading}
        onLoad={() => setLoaded(true)}
        onError={() => {
          setLoaded(true);
        }}
        ref={(img) => {
          if (img && img.complete && !loaded) {
            setLoaded(true);
          }
        }}
        src={getLoader(path, srcImgWidth, srcImgHeight, quality)}
        srcSet={srcSetDef}
        sizes={sizes}
        alt={alt}
      />
    </StyledImgFigure>
  );
};

export default Image;
